<app-i18n-dictionary>
    <span [attr.transid]="passwordPlaceholderTextId" i18n="@@password-placeholder">Password</span>
    <span [attr.transid]="confirmPasswordPlaceholderTextId"
          i18n="@@confirm-password-placeholder">Confirm Password</span>
    <span [attr.transid]="contactHrefSubjectTextId"
          i18n="@@contact-href-subject">Access for Hering Berlin B2B portal</span>
    <span [attr.transid]="contactHrefBodyTextId" i18n="@@contact-href-body">\n</span>
    <!--<span [attr.transid]="contactHrefBodyTextId" i18n="@@login-form_contact-href-body">Please tell us your name as well as the name and subject of your company.-->
    <!--\n\nFirst Name:-->
    <!--\nLast Name:-->
    <!--\n\nCompany Name:-->
    <!--\nCompany Subject:-->
    <!--</span>-->
</app-i18n-dictionary>

<form fxLayout="column" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field>
        <input appIosAutoFillFix type="password" matInput
               [placeholder]="i18nDictionary.get(passwordPlaceholderTextId)"
               formControlName="password" [minlength]="minPasswordLength"/>
        <mat-error *ngIf="passwordControl.hasError('required')"
                   i18n="@@password-error-required">Password is required
        </mat-error>
        <mat-error *ngIf="passwordControl.hasError('pattern')"
                   i18n="@@password-error-pattern">Password should have a minimum of eight characters, at least one
            uppercase letter, one lowercase letter, one number and one special character
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <input appIosAutoFillFix type="password" matInput
               [placeholder]="i18nDictionary.get(confirmPasswordPlaceholderTextId)"
               formControlName="confirmPassword" [minlength]="minPasswordLength"/>
        <mat-error *ngIf="confirmPasswordControl.hasError('mismatch')"
                   i18n="@@password-mismatch">
            Passwords don't match
        </mat-error>
    </mat-form-field>
    <div class="actions" fxLayout="row" fxLayoutAlign="center center">
        <button class="btn-primary" [disabled]="isPending" i18n="@@password-reset-form_submit-button">
            Submit
        </button>
        <mat-spinner [diameter]="25" *ngIf="isPending"></mat-spinner>
    </div>

    <button fxFlex="1 1 auto" class="btn-primary actions" [disabled]="isPending" i18n="@@password-reset-form_back-button" routerLink="/login">Return to login</button>
</form>

<p *ngIf="resetSuccessful" class="resetSuccessful"
   i18n="@@password-reset-form_request-reset_successful">
    Password reset successful! You can now log in.
</p>
<p *ngIf="resetError && !resetError.isGlobalMessage" class="resetError">
    {{ resetError.errorMessage }} [{{ resetError.errorCodeFormatted }}]
</p>

<app-contact-box></app-contact-box>
